import { CONFIG } from '@/config-globals';
import { usePageHeader } from '@/providers/page-header/use-page-header';
import { AdminTopbar } from './admin/admin-topbar';
import { BreadcrumbTrail } from './breadcrumbs';
import { Icon } from './icon';
import { SidebarTrigger } from './sidebar';

export const AppTopbar = () => {
  const { header } = usePageHeader();

  return (
    <AdminTopbar
      leading={
        <>
          <SidebarTrigger className="size-10 shrink-0 rounded-[11px] border border-border text-muted-foreground hover:border-ring hover:bg-raised hover:text-foreground [&_svg]:size-[18px]" />
          {header?.onBack && (
            <button
              type="button"
              onClick={header.onBack}
              aria-label="Voltar"
              className="flex size-10 shrink-0 items-center justify-center rounded-[11px] border border-border text-muted-foreground transition-colors hover:border-ring hover:text-sand"
            >
              <Icon name="chevron-left" className="size-[18px]" />
            </button>
          )}
        </>
      }
      crumb={<BreadcrumbTrail items={header?.items ?? []} />}
      title={header?.title ?? CONFIG.APP_NAME}
      action={
        <>
          <a
            href={CONFIG.MOBILE_APK_URL}
            target="_blank"
            rel="noopener noreferrer"
            title="Baixar o app Android (APK)"
            className="flex h-10 shrink-0 items-center gap-2 max-md:hidden rounded-[11px] border border-border px-3 text-[13px] font-semibold text-muted-foreground transition-colors hover:border-ring hover:text-sand"
          >
            <Icon name="download" className="size-[18px]" />
            <span>Baixar app</span>
          </a>
          {header?.action}
        </>
      }
    />
  );
};
